(function() {
    $(document).ready(function() {
        const toDosLength = document.getElementsByClassName('toDoBox').length;
        const links = document.querySelectorAll('.toDoBox .link');

        if (toDosLength > 0) {
            window._paq.push([
                'trackEvent',
                window.c24Lp.getMatomoEventCategory(),
                'todo_type_seen',
            ]);
        }

        links.forEach(el => el.addEventListener('click', () => {
            window._paq.push([
                'trackEvent',
                window.c24Lp.getMatomoEventCategory(),
                'todo_type_clicked',
            ]);
        }));
    });
})();
